import { Typography, List, Skeleton } from "antd";
import useFetch from "../../../hooks/useFetch";
import { useEffect, useState } from "react";

const { Title } = Typography;

function SeuDetails(props) {
  const { selectedSeu } = props;

  const [fetchWrapper] = useFetch();

  const [loading, setLoading] = useState(false);

  const [powerMeterList, setPowerMeterList] = useState([]);

  /* API to get power meter list for selected seu */
  function getSelectedSeuPowerMeterDetails() {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/getSelectedSeuPowerMeterDetails",
      body: {
        seu_id: selectedSeu.ID,
      },
      onSuccess: (fetch_output) => {
        setLoading(false);
        if (fetch_output.status === true) {
          setPowerMeterList(fetch_output.power_meter_list);
        }
      },
    });
  }

  useEffect(() => {
    if (selectedSeu) {
      getSelectedSeuPowerMeterDetails();
    }
  }, [selectedSeu]);

  return (
    <>
      {loading ? (
        <Skeleton />
      ) : (
        <div>
          <Title level={3} className="mt-0">
            Device List
          </Title>

          {selectedSeu ? (
            <div>
              <Title level={2} className="mt-0">
                {selectedSeu ? selectedSeu.Name : ""}
              </Title>

              {powerMeterList.length === 0 ? (
                <p>There is no power meter for this seu.</p>
              ) : (
                <List
                  dataSource={powerMeterList}
                  renderItem={(item) => <List.Item>{item}</List.Item>}
                />
              )}
            </div>
          ) : (
            <div>
              You can view the device list belongs to the SEU by clicking on the
              SEU name on the left hand side.
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default SeuDetails;
